// extracted by mini-css-extract-plugin
export var badge = "dl_jM";
export var caption = "dl_fB";
export var header = "dl_q";
export var headerWithHorizontalRule = "dl_jJ";
export var v1 = "dl_jK";
export var v2 = "dl_jL";